import totalmenuIcon from './totalmenu.png';
import governmentIcon from './government.png';
import economicsIcon from './economics.png';
import societyIcon from './society.png';
import livingcultureIcon from './livingculture.png';
import scienceIcon from './science.png';
import worldIcon from './world.png';

export const categories = [
    { id: 'sub1', label: '홈', icon: totalmenuIcon },
    { id: 'sub3', label: '정치', icon: governmentIcon },
    { id: 'sub4', label: '경제', icon: economicsIcon },
    { id: 'sub5', label: '사회', icon: societyIcon },
    // { id: 'sub6', label: '생활/문화', icon: livingcultureIcon },
    { id: 'sub7', label: 'IT/과학', icon: scienceIcon },
    { id: 'sub9', label: '세계', icon: worldIcon }
];
